<template>
  <v-container fluid>
    <!--
    <v-card class="elevation-2 blue lighten-2">
      <v-card-title class="headline"
        >¿Interesado en probar O2Digital?</v-card-title
      >
      <v-card-text  class="blue lighten-2"
        >Déjanos tus datos y contactaremos contigo de forma
        inmediata.</v-card-text
      >
    </v-card>

    <v-card  class="blue lighten-2">
      <v-card-title class="blue lighten-2">
        <h2 class="display-1 white--text font-weight-light"></h2>
      </v-card-title>
      <v-container>
        <v-layout>
          <v-flex xs10>
            Por favor, rellena el formulario para solicitar una cuenta de prueba
          </v-flex>
          <v-flex xs2> </v-flex>
        </v-layout>
      </v-container>
    </v-card>

-->
      <v-container bg fill-height grid-list-md text-xs-center>
        <v-layout row wrap align-center>
          <v-flex>
     
            <label  class="orange--text darken-4 bold">
              Rellena tus datos en este formulario, así podremos ponernos en contacto para proporcionarte el acceso a nuestros servicios.
            </label>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="name"
            :counter="200"
            :rules="nameRules"
            label="Nombre"
            required
          ></v-text-field>

          <v-text-field
            v-model="company"
            :counter="100"
            label="Empresa"
            required
          ></v-text-field>

          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
          ></v-text-field>

          <v-text-field
            v-model="phone"
            :rules="phoneRules"
            label="Teléfono"
          ></v-text-field>

          <v-text-field
            v-model="description"
            label="Si puedes, danos algún detalle del tipo de procesos en los que usarías nuestros servicios "
            required
          ></v-text-field>

          <v-checkbox
            v-model="checkbox"
            :rules="[v => !!v || 'Debes aceptar para continuar!']"
            required
           color="orange"
          >
            <template v-slot:label>
              <div slot="label">
                Quiero recibir novedades y comunicaciones comerciales de Securyty a través del email, otros medios y acepto las
                <a
                  href="#"
                  
                  ><strong class="orange--text darken-1">Condiciones de Uso</strong></a
                >
              </div>
            </template>
          </v-checkbox>

          <v-checkbox
            v-model="checkbox2"
            :rules="[v => !!v || 'Debes aceptar para continuar!']"
            required
            color="orange"
          >
            <template v-slot:label>
              <div slot="label">
                He podido leer y entiendo la información sobre el uso de mis datos personales de acuerdo con la 
                <a href="#" 
                  ><strong class="orange--text darken2"
                    >Política de Privacidad</strong
                  ></a
                >
              </div>
            </template>
          </v-checkbox>

          <v-btn color="white" class="mr-4 orange--text darken-1" @click="reset" v-if="!showFirma">
            Borrar
          </v-btn>
          <v-btn
            :disabled="!valid"
            round color="orange darken-4" dark bold outline  text-color="white"
            class="mr-4 elevation-5"
            v-if="!showFirma"
            @click="submitContactInfo"
          >
            Registrar Contacto
          </v-btn>


          <v-btn
            round color="orange darken-4" dark bold outline  text-color="white"
            class="mr-4"
            @click="createSignature()"
            v-if="showFirma"
          >
            Generar Operación de Firma
          </v-btn>
        </v-form>
          </v-flex>
        </v-layout>
      </v-container>  

    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-title class="headline">Gracias</v-card-title>

        <v-card-text>
          Has registrado correctamentee tus datos. En breve nos pondremos en
          contacto.<br />
          Si quieres ver un ejemplo de identficaión por video pulsa en el botón  VideoIdentificación
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn round color="orange darken-4" dark bold outline  text-color="white" text @click="dialog = false">
            Cerrar
          </v-btn>
          <v-btn round color="orange darken-4" dark bold outline  text-color="white" text @click="createParteViajero()">
            VideoIdentificación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
//import CreateSignPage from "./CreateSignPage";
//import firebase from "firebase";
import axios from "axios";

export default {
  components: {
    //    CreateSignPage
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      isCreateSign: false,
      page: {
        title: "API & Integration",
        headline: "Using Securyty in your apps",
        description: `Using Securyty from your apps`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      valid: true,
      name: "",
      description: "",
      nameRules: [
        v => !!v || "Nombre es obligatorio",
        v => (v && v.length <= 200) || "Demasiado largo"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail es obligatorio",
        v => /.+@.+\..+/.test(v) || "E-mail debe ser válido"
      ],
      phone: "",
      phoneRules: [
        v => !!v || "El teléfono es obligatorio",
        v => (v && v.length >= 7) || "Debe ser válido"
      ],
      select: null,

      checkbox: false,
      checkbox2: false,
      dialog: false,
      showFirma: false
    };
  },
  methods: {
    createSignature() {
      this.$router.push("CreateSignPageLight");
      //this.isCreateSign = true;
    },
    createParteViajero() {
      this.$router.push("CreateParteViajeroPage");
      //this.isCreateSign = true;
    },    
    createVideo() {
      window.location="https://videoservices.securyty.com/securyty/identification"
//this.isCreateSign = true;
    },    
    submitContactInfo() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        var contact = {
          name: this.name,
          email: this.email,
          company: this.company,
          phone: this.phone,
          message: this.description,
          creationdate: Date.now(),
          state: "RECEIVED"
        };
        const self = this;
        var d = new Date();
        var n = d.getTime();
        this.$db
          .collection("contacts")
          .doc("C" + n)
          .set(contact)
          .then(function() {
            console.log("Document successfully written!");
            self.dialog = true;
          });

        axios
          .post(
            `https://us-central1-globalservices-189612.cloudfunctions.net/emailMessage`,
            contact
          )
          .then(
            success => {
              console.log(success);
              self.showFirma = true;
              //      this.createSignature();
            },
            () => {
              this.snackBarColor = "error";
              this.snackBarText =
                "Ha ocurrido algún problema al registrar tu petición";
              this.isSnackBarVisible = true;
            }
          );
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>
